export const AddDaysToDate = (date, days) => {
  const newDate = new Date();
  newDate.setDate(date.getDate() + days);
  return newDate;
};

export const addMonthsToDate = (date, months) => {
  const newDate = new Date();
  newDate.setMonth(date.getMonth() + months);
  return newDate;
};

export const DateToLocalDateString = (date) => date.toLocaleDateString('pt-BR');
